// The Main Site Object
window.Site = {

    popovers : document.querySelectorAll('.modal'),
    entries  : document.querySelector('.entries'),
    filters  : document.querySelectorAll('.tag-label'),
    filter   : null,
    active   : null,

    // Init Function
    liftoff : () => {
        
        //Site.disableBackgroundOnPopover()
        Site.filterListOnClick()

    },

    disableBackgroundOnPopover : () => {

        Site.popovers.forEach(modal => {
            modal.addEventListener('beforetoggle' , (event) => {
                document.body.classList.toggle('modal-is-open')
            })
        })

    },

    filterListOnClick : () => {


        Site.filters.forEach(input => {
            input.addEventListener('click' , event => {

                if (Site.active) {
                    Site.active.forEach(entry => { entry.classList.remove('is-visible') })
                }

                // reset the selection
                if (input.classList.contains('is-selected')) {

                    // remove the filtered class on the list
                    Site.entries.classList.remove('filtered');

                    input.classList.remove('is-selected')
                    Site.filter = null;
                    return;
                }

                // If there's an already active filter, disable it
                if (Site.filter) Site.filter.classList.remove('is-selected')

                // Store the active input
                Site.filter = input;

                // Add the filtered class
                Site.entries.classList.add('filtered');

                // Add the active class on all the correct items
                Site.active = document.querySelectorAll(`.entry[data-cat~="${input.value}"]`)

                if (Site.active) {

                    Site.active.forEach(entry => {
                        entry.classList.add('is-visible')
                    })

                }

                input.classList.add('is-selected')
            })
        })
    }

    


}

// Launch The Script
Site.liftoff()